module.exports = __webpack_public_path__ + "img/icon_unselected_niulong.f6950b68.png";